<template>
<div class="webdatalist">
    <f7-list media-list class="searchbar-found" id="contacts-list">

      <div class="showSmallScreenOnly">
        <ul v-for="(group, key) in contacts" :key="key">
          <f7-list-item :title="key" group-title></f7-list-item>
          <li v-for="contact in group" :key="contact.id" class="testTap boxRequest swipeout">
            <div class="item-content swipeout-content">
              <div class="item-inner" @click="contactDetail(contact)">
                <div class="row" style="margin-left: 0px; margin-right: 0px;">
                  <div class="item-title">{{ contact.label }}</div>
                  <div class="item-after">{{ contact.zoneCode }}</div>
                </div>
                <div class="item-subtitle">{{ contact.name }}</div>
              </div>
            </div>
            <div class="swipeout-actions-right">
              <a class="swipeout-create action3" href="#" @click="editContact(contact, $event)"
              v-bind:style="[canRemoveContact ? {} : {'color':'grey', 'opacity':'50%'}]">
                {{ $t('common.edit_label') }}
              </a>
              <a class="swipeout-delete action4" href="#"
                @click="removeContact(contact, $event)"
                v-bind:style="[canRemoveContact ? {} : {'color':'grey', 'opacity':'50%'}]" delete>
                {{ $t('common.rm_label') }}
              </a>
            </div>
          </li>
        </ul>
      </div>

      <div class="showLargeScreenOnly">
        <ul v-for="(group, key) in contacts" :key="key">
          <f7-list-item :title="key" group-title></f7-list-item>
          <li v-for="contact in group" :key="contact.id" class="testTap boxRequest swipeout">
            <div class="item-content" @click="contactDetail(contact)">
              <div class="item-inner">
                <div class="item-title">{{ contact.label }}</div>
              </div>
              <div class="item-title contactItem">{{ contact.name }}</div>
              <div class="item-after" style="padding-left: 0px;">{{ contact.zoneCode }}</div>
              <div class="item-media button-swipe-out" style="margin-right: 50px;">
                <button class="button-big button-bank-account boxRequest"
                  :title="editlabel"
                  @click="editContact(contact, $event)">
                  <i class="icon-edit icon icon-float-sub-button"
                    v-bind:style="[canEditContact ? {} : {'color':'grey', 'opacity':'50%'}]"></i>
                </button>
                <button class="button-big button-bank-account boxRequest"
                  :title="removelabel"
                  @click="removeContact(contact, $event)" delete>
                  <!-- <i class="fa fa-times-circle button-delete" style="margin-bottom: 0.5%; color: red;"></i> -->
                  <f7-icon f7="close" class="button-delete"
                  v-bind:style="[canRemoveContact ? {} : {'color':'grey', 'opacity':'50%'}]"></f7-icon>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </f7-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'ContactList',
  props: ['contacts'],
  data () {
    return {
      editlabel: '',
      removelabel: '',
      canRemoveContact: false,
      canEditContact: false
    }
  },
  created () {
    this.canRemoveContact = this.$engine.rights.rightIs('contact_supprimer', true)
    this.canEditContact = this.$engine.rights.rightIs('contact_editer', true)

    this.editlabel = this.$i18n.t('common.edit_item',
      {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
    this.removelabel = this.$i18n.t('common.rm_item',
      {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
  },
  methods: {
    editContact (contact, e) {
      e.stopPropagation()
      if (!this.canEditContact) {
        return
      }
      this.$engine.settings.set({currentContact: contact})
      var formData = {
        'username': contact.name,
        'identifier': contact.identifier,
        'iban': contact.iban,
        'label': contact.label,
        'phoneNumber': contact.phoneNumber,
        'address': contact.address,
        'city': contact.city,
        'zipCode': contact.zipCode,
        'typeContact': contact.typeContact
      }
      this.$f7.formFromData('#EditContactForm', formData)
      loadPage(this, {url: '/account/editContact/'})
    },
    contactDetail (contact) {
      this.$engine.settings.set({currentContact: contact})
      var formData = {
        'username': contact.name,
        'identifier': contact.identifier,
        'iban': contact.iban,
        'label': contact.label,
        'phoneNumber': contact.phoneNumber,
        'address': contact.address,
        'city': contact.city,
        'zipCode': contact.zipCode,
        'typeContact': contact.typeContact
      }
      this.$f7.formFromData('#EditContactForm', formData)
      loadPage(this, {url: '/account/contactDetail/'})
    },
    removeContact (contact, e) {
      e.stopPropagation()
      if (!this.canRemoveContact) {
        return
      }
      let that = this
      that.$engine.contacts
        .delete(contact.id)
        .then(resp => {
          that.$f7.modal({
            title: that.$i18n.t('contacts.cntct_dltd'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.identifier = ''
            that.username = ''
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
          }, 1000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
    }
  }
}
</script>
<style>
.testTap {
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// CMContactList.vue?07594b86